import { lazy } from 'react';

const EmployeeCreate = lazy(() => import('./EmployeeCreate'));

export default EmployeeCreate;
